import React, { useState, useEffect } from "react";
import "./styles.css";
// import { HiChevronRight, HiChevronLeft } from "react-icons/hi";
import ProductList from "../Products/ProductList";
import ProductModal from "../Products/ProductModal";
// import styles from "../../../styles/getAllItem.module.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { demoFeatured } from "../../../data/demoProducts";
import { PRODUCTS_URL } from "../../../config";

// const products = [
//   {
//     id: 1,
//     name: "Lormami Product 1",
//     image: require('../.././../assets/female.png'),
//     price: "$25,000",
//     stock: "4",
//   },
//   {
//     id: 2,
//     name: "Lormami Product 2",
//     image: require('../.././../assets/male.png'),
//     price: "$21,000",
//     stock: "2",
//   },
//   {
//     id: 3,
//     name: "Lormami Product 3",
//     image: require('../.././../assets/female.png'),
//     price: "$21,000",
//     stock: "2",
//   },
//   {
//     id: 4,
//     name: "Lormami Product 4",
//     image: require('../.././../assets/male.png'),
//     price: "$21,000",
//     stock: "2",
//   },
//   {
//     id: 5,
//     name: "Lormami Product 5",
//     image: require('../.././../assets/female.png'),
//     price: "$25,000",
//     stock: "4",
//   },
//   {
//     id: 6,
//     name: "Lormami Product 6",
//     image: require('../.././../assets/male.png'),
//     price: "$21,000",
//     stock: "2",
//   },
//   {
//     id: 7,
//     name: "Lormami Product 7",
//     image: require('../.././../assets/female.png'),
//     price: "$21,000",
//     stock: "2",
//   },
//   {
//     id: 8,
//     name: "Lormami Product 8",
//     image: require('../.././../assets/male.png'),
//     price: "$21,000",
//     stock: "2",
//   },
//   {
//     id: 79,
//     name: "Lormami Product 9",
//     image: require('../.././../assets/female.png'),
//     price: "$21,000",
//     stock: "2",
//   },
// ];

const BestSellers = () => {
  // const [, setCurrentSlide] = useState(0);

  const [products, setProducts] = useState(demoFeatured);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    // Fetch products on component mount
    const fetchProducts = async () => {
      try {
        const response = await fetch(PRODUCTS_URL);
        const data = await response.json();
        if (response.ok && data.products) {
          const featuredData = data.products.filter(
            (product) => product.isFeatured
          );
          // Fall back to demo products if the API has no featured items
          setProducts(featuredData.length ? featuredData : demoFeatured);
        } else {
          setProducts(demoFeatured);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        // API unreachable (e.g. backend offline) — show demo products
        setProducts(demoFeatured);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gap: "clamp(0.75rem, 3vw, 1.5rem)",
          width: "100%",
          maxWidth: "1280px",
          margin: "0 auto",
          padding: "clamp(2.5rem, 7vw, 5rem) var(--gutter)",
        }}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="colPro">
            <Skeleton height={0} style={{ paddingTop: "133%", borderRadius: 12 }} />
            <Skeleton width="70%" />
            <Skeleton width="40%" />
          </div>
        ))}
      </div>
    );
  }

  // The total number of slides
  // const totalSlides = Math.ceil(products.length / 3);

  // const goNext = () => {
  //   setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
  // };

  // const goPrev = () => {
  //   setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  // };

  return (
    <div className="slider-container">
      <div className="slider-header">
        {/* <div className="move">
          <HiChevronLeft onClick={goPrev} cursor="pointer" />
        </div> */}
        <hr className="horizontal-line" /> {/* Add this for the line */}
        <p className="slider-text">OUR BEST SELLERS</p>
        <hr className="horizontal-line" />
        {/* <div className="move">
          <HiChevronRight onClick={goNext} cursor="pointer" />
        </div> */}
      </div>

      <div className="slides">
        <ProductList
          data={products}
          setSelectedProduct={setSelectedProduct}
          setShowModal={setShowModal}
        />
        {showModal && selectedProduct && (
          <ProductModal
            showModal={showModal}
            setShowModal={setShowModal}
            product={selectedProduct}
          />
        )}
      </div>
      {/* <div className="pagination">
        {Array(totalSlides)
          .fill(0)
          .map((_, index) => (
            <div
              key={index}
              className={`pagination-dot ${
                currentSlide === index ? "active" : ""
              }`}
              onClick={() => setCurrentSlide(index)}
            ></div>
          ))}
      </div> */}
    </div>
  );
};

export default BestSellers;
